// extracted by mini-css-extract-plugin
export default {"myTable":"AccountsTable_myTable__NRWMd"};